export default __webpack_public_path__ + "static/media/new-cake.5b6add79.svg";